var _circle, _path, _path2, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.428 76.313a6.003 6.003 0 0 1-7.542-3.899L24 47.642 35.44 44l7.887 24.772a6.003 6.003 0 0 1-3.9 7.541Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 46c0-5.523 4.477-10 10-10h22v20H26c-5.523 0-10-4.477-10-10Z",
  fill: "#405B73"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 46,
  r: 6,
  fill: "#F4CC54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.079 30.772a2 2 0 0 1-.351 2.807l-4.5 3.5a2 2 0 0 1-2.456-3.158l4.5-3.5a2 2 0 0 1 2.807.351ZM82.079 60.728a2 2 0 0 0-.351-2.806l-4.5-3.5a2 2 0 1 0-2.456 3.157l4.5 3.5a2 2 0 0 0 2.807-.35ZM78 46a2 2 0 0 1 2-2h5.5a2 2 0 1 1 0 4H80a2 2 0 0 1-2-2Z",
  fill: "#F4CC54"
})));
export default SvgIcCall;